import { z } from "@/zod";

export default z.object({
  templateId: z.string(),
  enabledProductGroupList: z.boolean().optional(),
  productGroupListId: z.string().optional(),
});
